/**
 * Storage Yard Validation Schemas
 *
 * Zod schemas for storage yard-related forms and data validation.
 * Matches backend validation rules for consistency.
 */

import { z } from 'zod';

/**
 * Create Storage Yard Schema
 * Used for creating new storage yards
 */
export const createStorageYardSchema = z.object({
  name: z
    .string()
    .min(1, 'Yard name is required')
    .max(100, 'Yard name must be less than 100 characters'),
  address: z
    .string()
    .min(1, 'Address is required')
    .max(500, 'Address must be less than 500 characters'),
  region: z
    .string()
    .max(100, 'Region must be less than 100 characters')
    .optional(),
  capacity: z
    .number()
    .positive('Capacity must be a positive number')
    .int('Capacity must be a whole number')
    .optional(),
  notes: z
    .string()
    .max(1000, 'Notes must be less than 1000 characters')
    .optional(),
  isDefault: z.boolean().optional(),
  isActive: z.boolean().optional(),
});

export type CreateStorageYardDTO = z.infer<typeof createStorageYardSchema>;

/**
 * Update Storage Yard Schema
 * Used for updating existing storage yards (partial updates allowed)
 */
export const updateStorageYardSchema = createStorageYardSchema.partial();

export type UpdateStorageYardDTO = z.infer<typeof updateStorageYardSchema>;
